import React from 'react';
import Icon from '../../../components/AppIcon';

const ExecutiveSummary = ({ metrics }) => {
  const kpiCards = [
    {
      label: 'Total Consultations',
      value: metrics?.total || 0,
      icon: 'Calendar',
      bgColor: 'bg-[#E6F0F5]',
      iconColor: 'text-[#002B45]',
      description: 'All consultation bookings'
    },
    {
      label: 'Conversion Rate',
      value: `${metrics?.conversionRate || 0}%`,
      icon: 'TrendingUp',
      bgColor: 'bg-[#D1F5F0]',
      iconColor: 'text-[#1FB5A5]',
      description: 'Consultations to deals'
    },
    {
      label: 'Win Rate',
      value: `${metrics?.winRate || 0}%`,
      icon: 'Target',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-600',
      description: 'Deals won vs lost'
    },
    {
      label: 'Active Deals',
      value: metrics?.activeDeals || 0,
      icon: 'Briefcase',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
      description: 'In pipeline'
    },
    {
      label: 'Deals Won',
      value: metrics?.dealsWon || 0,
      icon: 'CheckCircle',
      bgColor: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
      description: 'Successfully closed'
    },
    {
      label: 'Completed Consultations',
      value: metrics?.completed || 0,
      icon: 'CheckCheck',
      bgColor: 'bg-[#E6F0F5]',
      iconColor: 'text-[#002B45]',
      description: 'Consultations finished'
    }
  ];

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-foreground mb-4">Executive Summary</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {kpiCards?.map((kpi, index) => (
          <div 
            key={index}
            className="bg-white rounded-xl shadow-elevation-1 p-6 hover:shadow-elevation-2 transition-shadow duration-300"
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 ${kpi?.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon name={kpi?.icon} size={24} className={kpi?.iconColor} />
              </div>
            </div>
            <div>
              <p className="text-3xl font-bold text-foreground mb-1">{kpi?.value}</p>
              <p className="text-sm font-medium text-muted-foreground mb-1">{kpi?.label}</p>
              <p className="text-xs text-gray-500">{kpi?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExecutiveSummary;